import { render, staticRenderFns } from "./ArticleExamDetail.vue?vue&type=template&id=72a187b8&scoped=true&"
import script from "./ArticleExamDetail.vue?vue&type=script&lang=js&"
export * from "./ArticleExamDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArticleExamDetail.vue?vue&type=style&index=0&id=72a187b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a187b8",
  null
  
)

component.options.__file = "ArticleExamDetail.vue"
export default component.exports